import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { featured } from "../../data/projects";
import { usePageMotion } from "../../hooks/usePageMotion";
export function PageEffects() {
  const { pathname, hash, key } = useLocation();
  usePageMotion();
  useEffect(() => {
    const p = featured.find((p) => pathname === `/work/${p.slug}`);
    document.title = p
      ? `${p.name} | Fabulous J`
      : "Fabulous J | Emmanuel Adegbulu, Software Engineer";
    const frame = requestAnimationFrame(() => {
      if (hash) {
        document.getElementById(hash.slice(1))?.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
            .matches
            ? "auto"
            : "smooth",
        });
      } else {
        window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash, key]);
  return null;
}
